<template>
	<gc-dialog
		title="取消任务"
		:show.sync="visible"
		@close="$emit('close-modal')"
		@cancel="$emit('close-modal')"
		@ok="handleSubmitForm"
		width="460px"
	>
		<el-form :model="modelForm" :rules="rules" ref="modelForm" label-position="top" label-width="100px">
			<el-form-item label="取消原因" prop="reason">
				<el-input
					size="small"
					v-model="modelForm.reason"
					type="textarea"
					:rows="3"
					resize="none"
					placeholder="请输入"
				></el-input>
			</el-form-item>
		</el-form>
	</gc-dialog>
</template>

<script>
import { ruleRequired, ruleMaxLength } from '@/utils/rules'
import { apiCancelBatchImportTask } from '@/apis/batchImportTask.api'
export default {
	name: 'BatchImportCancelTaskModal',
	props: {
		taskId: String,
	},
	data() {
		return {
			visible: true,
			modelForm: {
				reason: null,
			},
			rules: {
				reason: [ruleRequired(), ruleMaxLength(50)],
			},
		}
	},

	methods: {
		handleSubmitForm() {
			this.$refs.modelForm.validate(async valid => {
				if (valid) {
					const searchParams = {
						...this.modelForm,
						taskId: this.taskId,
					}
					await apiCancelBatchImportTask(searchParams)
					this.$message.success('取消任务成功')
					this.$emit('close-modal', true)
				}
			})
		},
	},
}
</script>
